import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { normalizeTemuShopTypeSlug } from '@/temu-platform/constants/temuRoutes';
import TemuOrderListPage from '@/temu-platform/modules/aftersales/OrderListPage';

/** 全托订单根路径 → 备货发货；半托/本土仍为订单列表 */
export default function TemuOrdersIndexRedirect() {
  const { shopType } = useParams();
  const slug = normalizeTemuShopTypeSlug(shopType) || 'semi';
  if (slug === 'full') {
    return <Navigate to="stocking" replace />;
  }
  return <TemuOrderListPage />;
}
